import React from "react";
import styles from "./Composer.module.css";
import { useComposer } from "../context/ComposerContext";

// Human readable model names
const modelDisplayNames: Record<string, string> = {
  fast: "Fast (GPT-4.1 Mini)",
  gpt41mini: "GPT-4.1 Mini",
  smart: "Smart (Claude 3.7 Sonnet)",
  claude4sonnet: "Claude 4 Sonnet",
  claude37sonnet: "Claude 3.7 Sonnet",
  gpt41: "GPT-4.1",
};

export const ModelSelector: React.FC = () => {
  const { messages, currentModel, setCurrentModel } = useComposer();
  const hasUserMessages = messages.some((msg) => msg.role === "user");

  const handleModelChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedModel = e.target.value;
    if (selectedModel) {
      setCurrentModel(selectedModel);
    }
  };

  if (hasUserMessages) {
    return currentModel ? (
      <div className={styles.modelDisplay}>
        {modelDisplayNames[currentModel as keyof typeof modelDisplayNames] ||
          currentModel}
      </div>
    ) : null;
  }

  return (
    <div className={styles.modelSelector}>
      <select
        onChange={handleModelChange}
        className={styles.modelSelect}
        defaultValue={currentModel || ""}
      >
        <option value="" disabled>
          Select Model
        </option>
        {Object.entries(modelDisplayNames).map(([key, displayName]) => (
          <option key={key} value={key}>
            {displayName}
          </option>
        ))}
      </select>
    </div>
  );
};
